// src/Footer.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Imgbtm from '../images/logo_galenium.png';

//import axios
import axios from 'axios';

const Footer = () => {
    const [email, setEmail] = useState("");
    const navigate = useNavigate();
    const [validation, setValidation] = useState([]);

    const newsletterHandler = async (e) => {
        e.preventDefault();

        //initialize formData
        const formData = new FormData();

        //append data to formData
        formData.append('email', email);
        //send data to server
        await axios.post('https://dev.jftheskinspecialist.com/api/newsletter', formData)
            .then(() => {

                //redirect to logi page
                navigate('/');
            })
            .catch((error) => {

                //assign error to state "validation"
                setValidation(error.response.data);
            })
    };

    const getLang = localStorage.getItem('lang_code');

    return (
        <footer className="bg-[#fc8319] text-white py-8">
            <div className="container mx-auto">
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-screen-lg mx-auto">

                    <div className='w-[200px] p-0'>
                        <h3 class="text-lg mb-4" style={{ color: '#ffeb8c', fontFamily: 'MuseoSansRounded700', fontSize: 18, paddingLeft: 20 }}>MAIN MENU</h3>
                        <ul class="space-y-2" style={{ color: '#ffeb8c', fontFamily: 'MuseoSansRounded700', fontSize: 13, listStyleType: 'none' }}>
                            <li><a href="/home" class="hover:underline">{getLang ==='id' ? 'Beranda' : 'Home' }</a></li>
                            <li><a href="/allproduct" class="hover:underline">{getLang === 'id' ? 'Produk' : 'Products'}</a></li>
                            <li><a href="/wheretobuy" class="hover:underline">{getLang === 'id' ? 'Beli Di Sini' : 'Where To Buy'}</a></li>
                            <li><a href="/blog" class="hover:underline">{getLang === 'id' ? 'Berita & Info' : 'Blog & Event'}</a></li>
                        </ul>
                    </div>

                    <div className='w-[390px] p-0'>
                        <h3 class="text-lg mb-4" style={{ color: '#ffeb8c', fontFamily: 'MuseoSansRounded700', fontSize: 18, paddingLeft: 20 }}>ACNE SERIES</h3>
                        <ul class="space-y-2" style={{ color: '#ffeb8c', fontFamily: 'MuseoSansRounded700', fontSize: 13, listStyleType: 'none' }}>
                            <li><a href="/product/merawat-kulit-jerawat" class="hover:underline">{getLang === 'id' ? 'Merawat Kulit Berjerawat' : 'Caring for acne prone skin'}</a></li>
                            <li><a href="/product/menyamarkan-noda-bekas-jerawat" class="hover:underline">{getLang ==='id' ? 'Menyamarkan Noda Bekas Jerawat' : 'Disguise Acne Scars' }</a></li>
                            <li><a href="/product/menjaga-jerawat" class="hover:underline">{getLang === 'id' ? 'Menjaga Jerawat' : 'Take Care Of Acne'}</a></li>
                        </ul>
                        <br />
                        <h5 className="text-lg font-bold mb-4" style={{ color: '#ffeb8c', fontFamily: 'MuseoSansRounded700', fontSize: 18, paddingLeft: 20 }}>DERMA CARE</h5>
                        <ul class="space-y-2" style={{ color: '#ffeb8c', fontFamily: 'MuseoSansRounded700', fontSize: 13, listStyleType: 'none' }}>
                            <li><a href="/product/derma-med-treatment">Derma Med Treatment</a></li>
                            <li><a href="/product/derma-protect-cool-sensation">Derma Protect Cool Sensation</a></li>
                        </ul>
                    </div>

                    <div className='w-[390px] p-1'>
                        <h3 class="text-lg mb-4" style={{ color: '#ffeb8c', fontFamily: 'MuseoSansRounded700', fontSize: 18, paddingLeft: 20 }}>CONTACT US</h3>
                        <ul class="pace-y-2" style={{ listStyleType: 'none' }}>
                            <li><p style={{ color: '#ffeb8c', fontFamily: 'MuseoSansRounded700', fontSize: 12 }}>Jl. Adityawarman No.67 Kebayoran Baru, <br />Kota Jakarta Selatan</p></li>
                            <li><p style={{ color: '#ffeb8c', fontFamily: 'MuseoSansRounded700', fontSize: 12 }}>info_jf@galenium.com</p></li>
                        </ul>
                    </div>

                    <div className='w-[390px] p-1'>
                        <h3 class="text-lg mb-4" style={{ color: '#ffeb8c', fontFamily: 'MuseoSansRounded700', fontSize: 18, paddingLeft: 20 }}>GET OUR NEWSLETTER</h3>
                        <ul class="pace-y-2 mx-auto" style={{ listStyleType: 'none' }}>
                            <li>
                                <p style={{ color: '#ffeb8c', fontFamily: 'MuseoSansRounded700', fontSize: 12 }} class="mb-4">Subscribe to our newsletter and be among the first to hear about new arrivals, special offers, and events.</p>
                                {
                                    validation.email && (
                                        <div className="alert alert-danger">
                                            {validation.email[0]}
                                        </div>
                                    )
                                }
                                <div class="flex mx-auto">
                                    <form onSubmit={newsletterHandler}>
                                        <input type="email" class="w-70 p-2 px-4 py-4 text-gray-800 rounded-l-md" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email address" />
                                        <button class="bg-[#FFFBF0] text-[#FF7D1A] font-bold px-4 py-4 rounded-r-md">SIGN UP</button>
                                    </form>
                                </div>
                            </li>
                        </ul>
                        
                    </div>
                </div><br />
                <div className="container mx-auto" style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                    <img src={Imgbtm} alt="" class="h-[60px]" />
                </div>
            </div>
        </footer>
    );
};

export default Footer;
